import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CommonResponse } from 'models';
import { BarMenu, BarMenuSerializers } from './models/IBarMenu';

// state class
export interface BarMenuState {
  loading: boolean;
  bar_menus: BarMenu[];
}

// init model state
const initialState: BarMenuState = {
  loading: false,
  bar_menus: [] as Array<BarMenu>,
};

// slice
const barMenuListSlice = createSlice({
  name: 'barMenuList',
  initialState,
  reducers: {
    fetchListOfBarMenu(state, action: PayloadAction<number>) {
      state.loading = true;
    },
    fetchListOfBarMenuSuccess(state, action: PayloadAction<CommonResponse<Array<BarMenu>>>) {
      state.bar_menus = action.payload.data;
      state.loading = false;
    },
    fetchListOfBarMenuFailed(state) {
      state.loading = false;
      state.bar_menus = [];
    },
    deleteBarMenu(state, action: PayloadAction<Array<number>>) {
      state.loading = true;
    },
    deleteBarMenuSuccess(state, action: PayloadAction<CommonResponse<Array<BarMenu>>>) {
      state.bar_menus = state.bar_menus.filter((obj1) => !action.payload.data.some((obj2) => obj2.id === obj1.id));
      state.loading = false;
    },
    deleteBarMenuFailed(state) {
      state.loading = false;
    },
    addNewBarMenu(state, action: PayloadAction<Array<BarMenuSerializers>>) {
      state.loading = true;
    },
    addNewBarMenuSuccess(state, action: PayloadAction<CommonResponse<Array<BarMenu>>>) {
      // state.bar_menus.push(...action.payload.data);
      state.bar_menus.unshift(...[...action.payload.data].reverse());
      state.loading = false;
    },
    addNewBarMenuFailed(state) {
      state.loading = false;
    },
  },
});

// Actions
export const barMenuListActions = barMenuListSlice.actions;

// Selectors
export const selectBarMenuList = (state: RootState) => state.barMenu.bar_menus;
//export const selectResMessages = (state: RootState) => state.barMenu.resMessage;

// Reducer
export const barMenuListReducer = barMenuListSlice.reducer;
